import React from 'react';
import { AlertCircle } from 'react-feather';
import { Text, TEXT_VARIANTS } from 'ui/Typography';
import IncompleteAssessmentSection from './IncompleteAssessmentSection';

const TranscriptText = ({ assessmentData, assessmentError, fullText }) => {
  const text = assessmentData?.formattedTranscription?.fullText || '';
  const truncatedText =
    fullText || text?.length < 210 ? text : `${text.substring(0, 210)}...`;

  const failureMessage =
    assessmentData?.formattedTranscription?.failureMessage || '';
  if (
    assessmentData.transcriptionStatus === 'failed' &&
    failureMessage.includes('has no audio')
  ) {
    return (
      <div className="mb-16 d-f ai-c">
        <AlertCircle className="c-error" width={16} />
        <Text className="c-error mr-10 ml-6" variant={TEXT_VARIANTS.BODY}>
          {t('automated_analysis.transcript.none')}
        </Text>
      </div>
    );
  }
  if (assessmentData.transcriptionStatus !== 'complete') {
    return (
      <IncompleteAssessmentSection
        status={assessmentData.transcriptionStatus}
        error={assessmentError}
        processText={t('automated_analysis.transcript.title')}
      />
    );
  }
  return (
    <div className="lh-36">
      <Text variant={TEXT_VARIANTS.BODY}>{truncatedText}</Text>
    </div>
  );
};

export default TranscriptText;
